import { Helmet } from 'react-helmet-async';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

import ErrorImage from './images/error.png';
import { useAuth } from '../../hooks/useAuth';
import { t } from '../../services/translation/translation';
import { PrimaryButton } from '../button/PrimaryButton';
import { SecondaryButton } from '../button/SecondaryButton';
import { LocaleSwitch } from '../locale-switch/LocaleSwitch';
import { ThemeSwitch } from '../ThemeSwitch';

export const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const { logoutMutation } = useAuth();

  return (
    <div className="min-h-screen h-auto relative flex items-center justify-center">
      <section className="flex flex-col justify-center mx-5">
        <Helmet>
          <title>Erreur</title>
        </Helmet>
        <div className="flex justify-center xl:h-2/3">
          <div className="w-full flex gap-2 flex-col items-center max-w-md">
            <img className="w-auto max-h-48 m-auto" alt="error" src={ErrorImage} />
            {isRouteErrorResponse(error) && error.status === 404 ? (
              <>
                <p className="text-7xl font-bold">404</p>
                <p className="text-3xl">{t('route-error.404')}</p>
              </>
            ) : (
              <p className="text-2xl text-center">{t('network.code-error')}</p>
            )}
            <div className="flex flex-col items-stretch">
              <PrimaryButton className="mt-2" onClick={() => navigate('/')}>
                {t('route-error.back-home')}
              </PrimaryButton>

              <SecondaryButton className="mt-2" onClick={() => logoutMutation.mutate()}>
                {t('route-error.logout')}
              </SecondaryButton>
            </div>
          </div>
        </div>
      </section>
      <div className="absolute top-4 right-4 flex flex-row items-center gap-2">
        <ThemeSwitch />
        <LocaleSwitch />
      </div>
    </div>
  );
};
